<template>
  <div>
    <page-header
      title="Terminals"
      breadcrumb="Dashboard >> Settings  >> Location"
    />

    <div class="flex justify-between mt-12 mb-2">
      <div class="flex">
        <div
          :class="{ active: currentTab == 'location' }"
          class="tab-item"
          @click="currentTab = 'location'"
        >
          <p>Terminals</p>
        </div>
        <div
          hidden
          :class="{ active: currentTab == 'tax' }"
          class="tab-item"
          @click="currentTab = 'tax'"
        >
          <p>Tax</p>
        </div>
      </div>
    </div>
    <locations-data-table v-if="currentTab == 'location'" />
    <tax-data-table v-if="currentTab == 'tax'" />
  </div>
</template>

<script>
import PageHeader from "@/components/UI/NewPageHeader";
import LocationsDataTable from "./Location/LocationsDataTable";
import TaxDataTable from "./Tax/TaxDataTable";
export default {
  components: {
    PageHeader,
    LocationsDataTable,
    TaxDataTable,
  },
  data() {
    return {
      currentTab: "location",
    };
  },
};
</script>

<style lang="scss" scoped>
.tab-item {
  cursor: pointer;
  // margin-right: 1rem;
  color: #5e646d;
  padding: 0.25rem 1.5rem;
  font-size: 0.9rem;
  &.active {
    background: #ffffff;
    box-shadow: 0px 4px 10px rgba(17, 21, 25, 0.1);
    border-radius: 5px;
    color: #fcc210;
    font-weight: bold;
  }
}
</style>
